import ApiService from "@/core/services/api.service";
import { SET_PAGE_LOADING } from "@/core/services/store/config.module";
// action types
export const UPDATE_TABLE_STRUCTURE = "getDYNDOCTableStructure";
export const UPDATE_TABLE_DATA = "getDYNDOCTableData";
export const EXPORT_TABLE_DATA = "exportDYNDOCTableData";

// mutation types
export const SET_TABLE_STRUCTURE = "setDYNDOCTableStructure";
export const SET_TABLE_DATA = "setDYNDOCTableData";
export const SET_TABLE_FILTER = "setDYNDOCTableFilter";
export const SET_TABLE_PAGE = "setDYNDOCTablePage";
export const SET_TABLE_PERPAGE = "setDYNDOCTablePerPage";
export const SET_TABLE_SORTBY = "setDYNDOCTableSortBy";
export const SET_TABLE_SORTORDER = "setDYNDOCTableSortOrder";
export const SET_EXPORT_LINK = "setDYNDOCExportLink";

const state = {
  export_link: null,
  table_structure: {},
  table_data: {},
  table_state: {
    page: 1,
    per_page: 50,
    sortBy: "id",
    sortOrder: "desc",
    filters: [],
  },
};

const getters = {
  getDYNDOCTableState(state) {
    return state.table_state;
  },

  getDYNDOCTableHeaders(state) {
    return state.table_structure.columns;
  },

  getDYNDOCTableFilters(state) {
    return state.table_structure.filters;
  },

  getDYNDOCTablePermissions(state) {
    return state.table_structure.permissions;
  },

  getDYNDOCTableData(state) {
    return state.table_data.data;
  },

  getDYNDOCTableProperties(state) {
    return state.table_structure.properties;
  },

  getDYNDOCExportUrl(state) {
    return state.export_link;
  },
};

const actions = {
  [UPDATE_TABLE_STRUCTURE](context) {
    return new Promise((resolve) => {
      ApiService.post("/settings/dynamic_documents")
        .then(({ data }) => {
          context.commit(SET_TABLE_STRUCTURE, data);
          resolve(data);
        })
        .catch((data) => {
          context.commit(SET_PAGE_LOADING, false);
          resolve(data);
        });
    });
  },
  [UPDATE_TABLE_DATA](context, payload) {
    context.commit(SET_PAGE_LOADING, true);
    return new Promise((resolve) => {
      ApiService.post("/settings/dynamic_documents/datatable", payload)
        .then(({ data }) => {
          context.commit(SET_TABLE_DATA, data);
          resolve(data);

          context.commit(SET_PAGE_LOADING, false);
          setTimeout(() => {
            window.scrollTo(0, 0);
          }, 100);
        })
        .catch((data) => {
          context.commit(SET_PAGE_LOADING, false);
          resolve(data);
        });
    });
  },
  [EXPORT_TABLE_DATA](context, payload) {
    context.commit(SET_PAGE_LOADING, true);
    return new Promise((resolve) => {
      ApiService.post("/settings/dynamic_documents/export", payload)
        .then(({ data }) => {
          // console.log("export data is ", data);
          context.commit(SET_EXPORT_LINK, data.url);
          resolve(data);
        })
        .catch((data) => {
          context.commit(SET_PAGE_LOADING, false);
          resolve(data);
        });
    });
  },
};

const mutations = {
  [SET_TABLE_FILTER](state, filter) {
    state.table_state.filters = filter;
  },
  [SET_TABLE_PAGE](state, page) {
    state.table_state.page = page;
  },
  [SET_TABLE_PERPAGE](state, perPage) {
    state.table_state.per_page = perPage;
  },
  [SET_TABLE_SORTBY](state, sortBy) {
    state.table_state.sortBy = sortBy;
  },
  [SET_TABLE_SORTORDER](state, sortOrder) {
    state.table_state.sortOrder = sortOrder;
  },
  [SET_TABLE_STRUCTURE](state, table_structure) {
    state.table_structure = table_structure.data;
  },
  [SET_TABLE_DATA](state, table_data) {
    state.table_data = table_data;
  },
  [SET_EXPORT_LINK](state, link) {
    state.export_link = link;
  },
};

export default {
  state,
  actions,
  mutations,
  getters,
};
